import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { AddExtensionInfo } from '../../actions/extension-action/extension.action';

export class ExtensionStateModel {
  extension: any;
}

@Injectable({
  providedIn: 'root'
})
@State<ExtensionStateModel>({
  name: 'extension',
  defaults: {
    extension: null
  }
})
export class ExtensionState {
  constructor() {}

  @Selector()
  static getExtensionInfo(state: ExtensionStateModel) {
    return state.extension;
  }

  @Action(AddExtensionInfo)
  addExtensionInfo({ getState, setState }: StateContext<ExtensionStateModel>, { extension }: AddExtensionInfo) {
    const state = getState();
    setState({
      ...state,
      extension
    });
  }
}
